import { render, staticRenderFns } from "./InvoiceDownload.vue?vue&type=template&id=67224827&scoped=true"
import script from "./InvoiceDownload.vue?vue&type=script&lang=js"
export * from "./InvoiceDownload.vue?vue&type=script&lang=js"
import style0 from "./InvoiceDownload.vue?vue&type=style&index=0&id=67224827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67224827",
  null
  
)

export default component.exports